var exports = {
  "kL": "container___Sle3_",
  "YQ": "codeCard__3-yPlr",
  "wx": "header__H2Ub3A",
  "j4": "languageLabel__oIqdr4",
  "DV": "codeBlock__ci8S74",
  "o1": "standaloneCodeBlock__FAsYCb",
  "yZ": "collapsed__ql_SDG",
  "aY": "headerButton__MhWXRE",
};

module.exports = exports;
